import React, {Component} from 'react';
import firebase from 'firebase';
import 'moment/locale/es';
import Alert from 'react-s-alert';
import './style.css';
import Select from 'react-select';
import Cancelaciones from './cancelaciones'
import unidDisp from '../../img/auto.png';
import reservaImg from '../../img/Reservar.png';


class AsignarConductor extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      empleadosV:[],
      reservas:[],
      empresa:[],
      empresaFill:'',
      seleElim: 0,
      rowTable:false,
      clicRowTable:false,
      ordeGenera:0,
      Empresa:[],
      clientes:[],
      todos:[],
      filtros: [
      { label: 'Todos', value: 'Todos'},
       { label: 'Viaje por dia - Estandar', value: 'Viaje por dia - Estandar'},
       {label: 'Multiples destinos - Estandar', value: 'Multiples destinos - Estandar'},
       {label: 'Unico destino - Estandar', value: 'Unico destino - Estandar'},
       {label: 'Unico destino - Empresarial', value: 'Unico destino - Empresarial'},
       {label: 'Multiples destinos - Empresarial', value: 'Multiples destinos - Empresarial'},
      ]
    };
    this.marcar = this.marcar.bind(this);
  }
  componentWillMount(){
   
  }
  componentDidMount(){
    this.cargarEmpleados();
    this.getData();
    this.cargarEmpresa();
    
  }

  cargarEmpleados = () => {
    firebase.database().ref('Empleados').once('value').then(snap => {
      let empleadosV = [];
      snap.forEach(element => {
        let objeto = element.val();
        objeto.key = element.key;
        let nombre = objeto.nombre;
        let obj = { label: nombre, value: element.key };
        empleadosV.push(obj);
      });
      this.setState({
        empleado:empleadosV
      })
    })
  }

  getData = () =>{
    firebase.database().ref('Clientes').once('value').then(snapC =>{
      let clientes = [];
      let empresas = [];
      snapC.forEach(element =>{
        let clientesd = element.val();
        clientesd.key = element.key;
        clientes.push(clientesd);
      })
      firebase.database().ref('Empresa').once('value').then(snapE =>{
          let empresas = [];
          snapE.forEach(element2 =>{
            let objeE = element2.val();
            objeE.key = element2.key;
            empresas.push(objeE);
          })
          firebase.database().ref('Empleados').once('value').then(snapEm =>{
            let empleados = [];
            snapEm.forEach(element2 =>{
              let objeEm = element2.val();
              objeEm.key = element2.key;
              empleados.push(objeEm);
            })
            this.setState({clientes, Empresa:empresas, empleados:empleados});
            this.obteReservasC();
        })
      })
    })
  }

  cargarEmpresa = () => {
    firebase.database().ref('Empresa').once('value').then(snap => {
      let empresaV = [];
      let ob = { label: 'Todos', value: 'Todos' };
      empresaV.push(ob);  
      snap.forEach(element => {
        let obje = element.val();
        let nombre = obje.codigo_empresa;
        let ob = { label: nombre, value: element.key };
        empresaV.push(ob);
      });
      this.setState({
        empresa:empresaV
      })
    })
  }

  obteReservasC =() =>{
    let {clientes, empleados} = this.state;
    firebase.database().ref('Reservas').on('value', snap =>{
      let reservas =[];
      let index = 0;
      snap.forEach(element => {
        let datos = element.val();
        datos.key = element.key;
       
        let da = datos.fechaInicial;
        let fecha = da.split('-')
        let fechaRes = new Date(fecha[2]+'-'+fecha[1]+'-'+fecha[0] +' '+datos.horaInicial)
        let fechaAct = new Date();
        let encontrardoConduct = '';
        let enconConduct = '';
        if(datos.estado !== 'programada' && datos.estado !== 'tomada' && fechaRes.getTime()>fechaAct.getTime() && datos.conductor !== ''){
          encontrardoConduct = clientes.find(emple => {
            return datos.cliente === emple.key;
          })
          enconConduct = empleados.find(emple => {
            return datos.conductor === emple.key;
          })
          if(encontrardoConduct !== undefined && enconConduct !== undefined){
            datos.empleados = {key:enconConduct.key, nombre:enconConduct.nombre};
            datos.nombreE = encontrardoConduct.nombre +' ' + encontrardoConduct.apellido;
            datos.horaI = datos.horaInicial;
            datos.direccionO = datos.nombreInicio;
            if(datos.tipoV === 'dia'){
              datos.tipoViaje = 'Viaje por dia - Estandar';
            }
            if(datos.tipoV === 'multiple'){
              datos.tipoViaje = 'Multiples destinos - Estandar';
            }
            if(datos.tipoV === 'unico'){
              datos.tipoViaje = 'Unico destino - Estandar';
            }
            this.darValores(index);
            reservas.push(datos);
            index = index + 1;
          }
        }
      })
      this.setState({reservas, ordeGenera:index, todos:reservas});
      this.ObtenerReservas();
    })
  }

  ObtenerReservas(){
    let {empresaFill, Empresa, ordeGenera} = this.state;
    const monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];
    firebase.database().ref('reserva').once('value', snap =>{
        let index = ordeGenera;
        let reservasd = [];
      snap.forEach(element => {
          let data = element.val();
          data.key = element.key;
          let encontrardoConduct = Empresa.find(emple => {
            return data.empresa === emple.key;
          })
          let fechaRes = new Date(data.fechaRese +' '+data.horaI);
          let fechaAct = new Date();
          if(data.asignada !== true && fechaRes.getTime() > fechaAct.getTime()){
            data.key = encontrardoConduct.key;
            data.nombreE = encontrardoConduct.codigo_empresa;
            let fechaRes = new Date(data.fechaRese)
            data.fechaInicial = fechaRes.getDate()+'-'+monthNames[fechaRes.getMonth()]+'-'+fechaRes.getFullYear();
            if(empresaFill === encontrardoConduct.key || empresaFill === '' || empresaFill === 'Todos'){
                this.darValores(index);
                reservasd.push(data);
                index = index + 1;
                this.setState({reservas:[...this.state.reservas,data], todos:[...this.state.todos,data]});
            }  
          }     
      });
    })
  }

  guardarConductor = (index,snap) =>{
    let id = 'emple'+index;
      if(this.state[id] !== ''){
        firebase.database().ref().child('Reservas/'+snap.key).update({
          conductor:this.state[id],
        })
        this.setState({[id]:'', ordeGenera:0})
        Alert.success('Cambio de conductor realizado con exito ', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
      }else{
        Alert.warning('Favor seleccione un conductor para realizar la reasignacion', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
      }
  }

  darValores = (index) =>{
    let id = 'emple'+index;
    this.setState({[id]:''})
  }

  addEmpreS = (event) =>{
    this.setState({empresaFill:event.value, reservas:[], ordeGenera:0});
    if(event.value === 'Todos'){
      this.obteReservasC();
    }else{
      this.ObtenerReservas();
    }
  }

  addCond = (event,index) =>{
    let id = 'emple'+index;
    this.setState({[id]:event.value});
  }

  handleRowTable(){
    this.setState({ rowTable:!this.state.rowTable});
  }


  marcar = (index) => {
    if(index !== this.state.seleElim){
      document.getElementById(this.state.seleElim).classList.toggle('active');
    }
    document.getElementById(index).classList.toggle('active');
    let id = 'emple'+index;
    this.setState({ seleElim:index, selecActua:this.state[id], selecIndex: index});
    this.setState({clicRowTable:!this.state.clicRowTable});
  }

  searchTipo = (event) =>{
    let {reservas, todos} = this.state;
    if(event.value !== "Todos"){
      this.setState({reservas:[]})
      let reserva = [];
      todos.map((element, index) => {
        if(element.tipoViaje === event.value){
          reserva.push(element);
        }
      });
      this.setState({reservas:reserva})
    }else{
      this.setState({reservas:todos})
    }
  }

  searchEmple = (event) =>{
    let {reservas, todos} = this.state;
    let dato = event.target.value;
    if(dato!== ''){
      let reserva = [];
      todos.forEach(element => {
        let cliente = (element.nombreE.toLowerCase().trim().search(dato.toLowerCase().trim()) >= 0 ? true : false);
        if(cliente){
          reserva.push(element);
        }
      });
      this.setState({reservas:reserva})
    }else{
      this.setState({reservas:todos})
    }
  }

  render(){
    let { reservas, empleado, empresa, filtros } = this.state;
    return(
    <div>
      <div className="container">
        <div className="row header-margin-top">
          <div className="col-md-1">
            <img src={reservaImg} className="img-fluid m-top-img"/>
          </div>
          <div className="col-md-11">
            <h3 className="title-blue">Reservas</h3>
            <span className="text-info">Asignación de conductores en reservas de viaje</span>
          </div>
        </div>
        

        <div className="row">
            <div className="col-12">
                <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                <li className="nav-item">
                    <a className="nav-link active show" id="unidades-tab" data-toggle="tab" href="#unidades" role="tab"
                    aria-controls="unidades" aria-selected="true"><img src={unidDisp}/> Asignación de reservas</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link nav-link2" id="asignacion-tab" data-toggle="tab" href="#asignacion" role="tab" aria-controls="asignacion"
                    aria-selected="false"> <span style={{fontSize:"16px"}}>X</span> Cancelaciones</a>
                </li>
                </ul>
            </div>
        </div>
        <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade active show" id="unidades" role="tabpanel" aria-labelledby="unidades-tab">
                
            <div className="row top-margin-filtros">
            <div className="col-12 col-md-3">
                <form>
                    <div className="form-group row">
                        <label className="col-sm-12 col-md-3 col-form-label">Filtros</label>
                        <div className="col-sm-12 col-md-9">
                        <Select  className="css-10nd86i-2" onChange={this.addEmpreS} options={empresa} /> 
                        </div>
                    </div>
                </form>
            </div>
            <div className="col-12 col-md-5">
                <form>
                    <div className="form-group row">
                        <label className="col-sm-12 col-md-4 col-form-label">Tipo de viaje</label>
                        <div className="col-sm-12 col-md-7">
                          <Select onChange={this.searchTipo} options={filtros} /> 
                        </div>
                    </div>
                </form>
            </div>
            <div className="col-12 col-md-4">
                <form>
                    <div className="form-group row">
                        <label className="col-sm-12 col-md-3 col-form-label">Cliente</label>
                        <div className="col-sm-12 col-md-9">
                          <input onChange={this.searchEmple} type="text" className="form-control" placeholder="Buscar cliente"/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="row">
          <div className="col-12">
          <div className="table-responsive top-margin-table text-center">
          <table className="table">
              <tbody>
              <tr>
                <th>Solicitante</th>
                <th>Fecha de servicio</th>
                <th>Hora inicio</th>
                <th >Origen</th>
                <th>Tipo de viaje</th>
                <th>Conductor asignado</th>
                <th colSpan="2">Reasignar reserva</th>
              </tr>
                {
                  reservas.map((snap, index) =>{
                    let tipo ='';
                    if(snap.tipoViaje === 'comun') snap.tipoViaje ='Unico destino - Empresarial'; 
                    if(snap.tipoViaje === 'Multiempresa') snap.tipoViaje ='Multiples destinos - Empresarial'; 
                    if(snap.tipoViaje !== 'Multiempresa' && snap.tipoViaje !== 'comun') snap.tipoViaje = snap.tipoViaje;
                    return(
                      <tr id={index} key={'reserva'+index} >
                        <td>{snap.nombreE}</td>
                        <td>{snap.fechaInicial}</td>
                        <td>{snap.horaI}</td>
                        <td>{snap.direccionO}</td>
                        <td>{snap.tipoViaje}</td>
                        <td>{snap.empleados.nombre}</td>
                        <td>
                        <div className="width-select-2">
                          <Select className="css-10nd86i-2" onChange={(event)=>this.addCond(event,index)} options={empleado} /> 
                        </div>
                        </td>
                        <td>
                        <button onClick={()=>this.guardarConductor(index,snap)} className="btn btn-small-orange">Reasignar</button>
                        </td>
                      </tr>
                    )
                  })
                }
               
              </tbody>
            </table>
            </div>
          </div>
        </div>
        {
          this.state.clicRowTable?
          <div className="row top-margin-filtros">
          <div className="col-12 col-md-8 offset-md-2">
              <form>
                  <div className="form-row">
                      <div className="col-md-12">
                      <label>Justificación</label>
                      </div>
                      <div className="col-md-10">
                          <div className="form-group">
                          <textarea className="bg-form-control form-control" rows="3"></textarea>
                          </div>
                      </div>
                      <div className="col-md-2">
                          <button type="button" className="btn btn-danger">Cancelar viaje</button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
        :
        <div></div>
        }
    </div>

      <div className="tab-pane fade" id="asignacion" role="tabpanel" aria-labelledby="asignacion-tab">
      <Cancelaciones/>
      </div>
    </div>
    </div>
  </div>
    )
  }
}
export default AsignarConductor;




// WEBPACK FOOTER //
// ./src/Components/Reservas/asignarConductor.js